export default function LearnerIcon() {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="40" height="40" rx="12" fill="#3B82F6" fillOpacity="0.2" />
      <ellipse
        cx="20"
        cy="24.5"
        rx="6"
        ry="2.5"
        stroke="#156EFF"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <circle
        cx="20"
        cy="16"
        r="3"
        stroke="#156EFF"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M14.4482 21.2617C13.5371 21.756 12.8341 22.3699 12.4199 23.0596C12.1732 23.1255 11.9467 23.2008 11.7432 23.2822C11.343 23.4423 11.0694 23.6142 10.9082 23.7666C10.7487 23.9175 10.75 23.9965 10.75 24C10.75 24.0035 10.7487 24.0825 10.9082 24.2334C11.0694 24.3858 11.343 24.5577 11.7432 24.7178C11.8315 24.7531 11.9247 24.7858 12.0215 24.8184C12.1 25.4499 12.41 26.0442 12.9043 26.5771C12.2683 26.468 11.686 26.3105 11.1855 26.1104C10.681 25.9085 10.2227 25.6492 9.87793 25.3232C9.53149 24.9956 9.25 24.5488 9.25 24C9.25 23.4512 9.53149 23.0044 9.87793 22.6768C10.2227 22.3508 10.681 22.0915 11.1855 21.8896C12.0694 21.5361 13.2085 21.3131 14.4482 21.2617Z"
        fill="#156EFF"
      />
      <path
        d="M25.5508 21.2617C26.7909 21.313 27.9304 21.536 28.8145 21.8896C29.319 22.0915 29.7773 22.3508 30.1221 22.6768C30.4685 23.0044 30.75 23.4512 30.75 24C30.75 24.5488 30.4685 24.9956 30.1221 25.3232C29.7773 25.6492 29.319 25.9085 28.8145 26.1104C28.3138 26.3106 27.7311 26.468 27.0947 26.5771C27.5893 26.0441 27.899 25.45 27.9775 24.8184C28.0747 24.7857 28.1682 24.7532 28.2568 24.7178C28.657 24.5577 28.9306 24.3858 29.0918 24.2334C29.2513 24.0825 29.25 24.0035 29.25 24C29.25 23.9965 29.2513 23.9175 29.0918 23.7666C28.9306 23.6142 28.657 23.4423 28.2568 23.2822C28.053 23.2007 27.8261 23.1255 27.5791 23.0596C27.1648 22.3699 26.4621 21.7559 25.5508 21.2617Z"
        fill="#156EFF"
      />
      <path
        d="M25 14.25C26.5188 14.25 27.75 15.4812 27.75 17C27.75 18.5188 26.5188 19.75 25 19.75C24.5146 19.75 24.0599 19.622 23.6641 19.4014C24.0069 19.0322 24.2941 18.6112 24.5137 18.1514C24.6632 18.2146 24.8274 18.25 25 18.25C25.6904 18.25 26.25 17.6904 26.25 17C26.25 16.3096 25.6904 15.75 25 15.75C24.9977 15.75 24.9954 15.75 24.9932 15.75C24.9676 15.2314 24.8632 14.7338 24.6914 14.2686C24.7928 14.2572 24.8956 14.25 25 14.25Z"
        fill="#156EFF"
      />
      <path
        d="M15 14.25C15.104 14.25 15.2066 14.2573 15.3076 14.2686C15.1359 14.7337 15.0314 15.2315 15.0059 15.75C15.0039 15.75 15.002 15.75 15 15.75C14.3096 15.75 13.75 16.3096 13.75 17C13.75 17.6904 14.3096 18.25 15 18.25C15.1723 18.25 15.336 18.2144 15.4854 18.1514C15.7049 18.6113 15.993 19.0321 16.3359 19.4014C15.9401 19.622 15.4854 19.75 15 19.75C13.4812 19.75 12.25 18.5188 12.25 17C12.25 15.4812 13.4812 14.25 15 14.25Z"
        fill="#156EFF"
      />
    </svg>
  );
}
